<script setup>
import { ref, onMounted } from 'vue';
import { HTTP } from '@/Api/http-common';
import GameCategory from '../components/GameCategory.vue';
import HeroSection from '../components/HeroSection.vue';
// import gameService from '../services/gameService';

const featuredGames = ref([]);
const newGames = ref([]);
const arcadeGames = ref([]);
const sportGames = ref([]);
const puzzleGames = ref([]);
const strategyGames = ref([]);

const originalGames = ref([]);

const gameCategories = ref([
  {
    id: 'Strategy',
    title: 'Strategy',
    icon: 'bi-people-fill',
    image: 'https://images.pexels.com/photos/1103242/pexels-photo-1103242.jpeg'
  },
  {
    id: 'featured',
    title: 'featured',
    icon: 'bi-compass-fill',
    image: 'https://images.pexels.com/photos/1271619/pexels-photo-1271619.jpeg'
  },
  {
    id: 'Arcade',
    title: 'Arcade',
    icon: 'bi-flower1',
    image: 'https://images.pexels.com/photos/2113855/pexels-photo-2113855.jpeg'
  },
  {
    id: 'Sports',
    title: 'Sports',
    icon: 'bi-car-front-fill',
    image: 'https://images.pexels.com/photos/3311574/pexels-photo-3311574.jpeg'
  },
  {
    id: 'originals',
    title: 'originals',
    icon: 'bi-controller',
    image: 'https://images.pexels.com/photos/3165335/pexels-photo-3165335.jpeg'
  },
  {
    id: 'Puzzle',
    title: 'Puzzle',
    icon: 'bi-dpad-fill',
    image: 'https://images.pexels.com/photos/3945683/pexels-photo-3945683.jpeg'
  },
  {
    id: 'Quiz',
    title: 'Quiz',
    icon: 'bi-lightning-fill',
    image: 'https://images.pexels.com/photos/2142817/pexels-photo-2142817.jpeg'
  },
  {
    id: 'basketball',
    title: 'Basketball',
    icon: 'bi-dribbble',
    image: 'https://images.pexels.com/photos/358042/pexels-photo-358042.jpeg'
  },
  {
    id: 'bike',
    title: 'Bike',
    icon: 'bi-bicycle',
    image: 'https://images.pexels.com/photos/2158963/pexels-photo-2158963.jpeg'
  },
  {
    id: 'card',
    title: 'Card',
    icon: 'bi-suit-club-fill',
    image: 'https://images.pexels.com/photos/279009/pexels-photo-279009.jpeg'
  },
  {
    id: 'clicker',
    title: 'Clicker',
    icon: 'bi-mouse-fill',
    image: 'https://images.pexels.com/photos/2115257/pexels-photo-2115257.jpeg'
  },
  {
    id: 'dress-up',
    title: 'Dress Up',
    icon: 'bi-stars',
    image: 'https://images.pexels.com/photos/994523/pexels-photo-994523.jpeg'
  }
]);

onMounted(async () => {
  try {
    const response = await HTTP.get('GetMostViewed.php?LIMIT=8');
    const data = response.data.MostViewed.map(game => ({
      id: game.id,
      title: game.title_en,
      image: game.thumbnailUrl,
      tag: game.category
    }));
    featuredGames.value = data;
  } catch (error) {
    console.error('Failed to fetch featured games:', error);
  }

  try {
    const response = await HTTP.get('getGamesAll.php?LIMIT=8');
    const data = response.data.getAllGames.map(game => ({
      id: game.id,
      title: game.title_en,
      image: game.thumbnailUrl,
      tag: game.category
    }));
    originalGames.value = data;
  } catch (error) {
    console.error('Failed to fetch featured games:', error);
  }


  try {
    const response = await HTTP.get('CatogeryById.php?Cat_id=Arcade&LIMIT=8');
    const data = response.data.getCatogery.map(game => ({
      id: game.id,
      title: game.title_en,
      image: game.thumbnailUrl,
      tag: game.category
    }));
    arcadeGames.value = data;
  } catch (error) {
    console.error('Failed to fetch strategy games:', error);
  }

  try {
    const response = await HTTP.get('CatogeryById.php?Cat_id=Quiz&LIMIT=8');
    const data = response.data.getCatogery.map(game => ({
      id: game.id,
      title: game.title_en,
      image: game.thumbnailUrl,
      tag: game.category
    }));
    newGames.value = data;
  } catch (error) {
    console.error('Failed to fetch strategy games:', error);
  }

  try {
    const response = await HTTP.get('CatogeryById.php?Cat_id=Sports&LIMIT=8');
    const data = response.data.getCatogery.map(game => ({
      id: game.id,
      title: game.title_en,
      image: game.thumbnailUrl,
      tag: game.category
    }));
    sportGames.value = data;
  } catch (error) {
    console.error('Failed to fetch strategy games:', error);
  }

  try {
    const response = await HTTP.get('CatogeryById.php?Cat_id=Puzzle&LIMIT=8');
    const data = response.data.getCatogery.map(game => ({
      id: game.id,
      title: game.title_en,
      image: game.thumbnailUrl,
      tag: game.category
    }));
    puzzleGames.value = data;
  } catch (error) {
    console.error('Failed to fetch strategy games:', error);
  }

  try {
    const response = await HTTP.get('CatogeryById.php?Cat_id=Strategy&LIMIT=8');
    const data = response.data.getCatogery.map(game => ({
      id: game.id,
      title: game.title_en,
      image: game.thumbnailUrl,
      tag: game.category
    }));
    strategyGames.value = data;
  } catch (error) {
    console.error('Failed to fetch strategy games:', error);
  }
});
</script>

<template>
  <div class="home-page">
    <HeroSection />

    <div class="container-fluid px-4">
      <!-- <div v-if="featuredGames.length === 0" class="skeleton-loader">
        <div v-for="n in 6" :key="n" class="skeleton-card"></div>
      </div>
      <div v-else> -->
        <GameCategory title="Featured games" :games="featuredGames" category="featured" />
      <!-- </div> -->

      <GameCategory title="Quiz games" :games="newGames" category="Quiz" />

      <GameCategory title="YalaaGame Originals" :games="originalGames" category="originals" />

      <!-- <GameCategory title="2 Player Games" :games="twoPlayerGames" category="2player" /> -->

      <div class="categories-grid">
        <router-link v-for="category in gameCategories" :key="category.id" :to="`/category/${category.id}`"
          class="category-card">
          <div class="category-icon">
            <i :class="`bi ${category.icon}`"></i>
          </div>
          <span class="category-title">{{ category.title }}</span>
        </router-link>
      </div>

      <GameCategory title="Arcade Games" :games="arcadeGames" category="Arcade" />

      <GameCategory title="Sport Games" :games="sportGames" category="Sports" />

      <GameCategory title="Puzzle Games" :games="puzzleGames" category="Puzzle" />

      <GameCategory title="Strategy Games" :games="strategyGames" category="Strategy" />
    </div>
  </div>
</template>

<style scoped>
.home-page {
  padding-bottom: 2rem;
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin: 2rem 0;
}

.category-card {
  background-color: #1a1b26;
  border-radius: 12px;
  padding: 1.5rem;
  text-align: center;
  text-decoration: none;
  transition: transform 0.2s ease, background-color 0.2s ease;
}

.category-card:hover {
  transform: translateY(-5px);
  background-color: #2d2d3a;
}

.category-icon {
  font-size: 2rem;
  color: #7e3af2;
  margin-bottom: 0.5rem;
}

.category-title {
  color: #e5e7eb;
  font-weight: 500;
  font-size: 0.9rem;
}

.skeleton-loader {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 1rem;
  margin: 2rem 0;
}

.skeleton-card {
  border-radius: 12px;
  overflow: hidden;
  position: relative;
  background-color: #1a1b26;
  height: 200px;
  animation: pulse 1.5s ease-in-out infinite;
}

.skeleton-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.2);
}

@keyframes pulse {
  0% {
    background-color: #1a1b26;
  }
  50% {
    background-color: #2d2d3a;
  }
  100% {
    background-color: #1a1b26;
  }
}

@media (max-width: 768px) {
  .categories-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }

  .category-card {
    padding: 1rem;
  }

  .category-icon {
    font-size: 1.5rem;
  }

  .category-title {
    font-size: 0.8rem;
  }

  .skeleton-loader {
    grid-template-columns: repeat(2, 1fr);
  }

  .skeleton-card {
    height: 150px;
  }
}

@media (max-width: 1024px) {
  .skeleton-loader {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>